<template>
  <div class="section fp-section mb-3" data-anchor="first-section">
    <!-- Hero Area -->
    <Loading :loaded="loaded"></Loading>
    <div class="home text-center " v-if="slides && slides.length">
      <VueSlickCarousel v-bind="option">
        <div v-for="slide in slides" v-bind:key="'slide-'+slide.id">
          <div>
            <div class="testimonial-box m-1" >
              <img :src="slide.image" class="" alt="" width="90">
              <div class="box">
              <div class="ratings-icons">
                <span class="fa fa-star-o">&#9733;</span>
                <span class="fa fa-star">&#9733;</span>
                <span class="fa fa-star">&#9733;</span>
                <span class="fa fa-star">&#9733;</span>
                <span class="fa fa-star">&#9733;</span>
              </div>
              <h4>{{slide.name}}</h4>
              <p>{{slide.comment}}</p>
              </div>
            </div>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
  </div>

</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import SliderItem from './SliderItem'
import Loading from './Loading'
export default {
  name: 'Review',
  components: {
    Loading,
    VueSlickCarousel,
    SliderItem},
  data () {
    return {
      loaded: false,
      slides: [],
      option: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2
            }
          },

          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 639,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },
  mounted () {
    this.getSlides()
    const self = this
    self.$eventHub.$on('language-changed', function () {
      self.getSlides()
    })
  },
  methods: {
    getSlides () {
      this.axios.get(this.$host + 'review').then(resp => {
        const self = this
        self.loaded = true

        this.slides = resp.data.data
      }).catch(() => {
        this.loaded = true
      })
    }
  }
}

</script>

<style scoped>
.testimonial-box img {
  display: inline-block;
  margin: 0 0 15px;
  height: 200px;
  width:auto;
}
.testimonial-box h4 {
  color: #fe4819;
}
.testimonial-box{
  -webkit-box-shadow: 0 5px 10px rgb(85 85 85 / 20%);
  box-shadow: 0 5px 10px rgb(85 85 85 / 20%);
  margin-top:-10px;
}
.testimonial-box p {
  margin-bottom: 10px;
  font-size: 11px;
  font-style: italic;
  font-weight: 400;
  height: 80px;
  text-overflow: revert;
  overflow: hidden;
  line-height: 1.1;
}
.ratings-icons {
  color: #fec42d;
  margin-bottom: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/Review.vue